import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/animal-debt/left-unicorn.webp";
import BgImg1 from "../../../images/case-studies/animal-debt/right-unicorn.webp";

function Behindthesceneanimal() {
  return (
    <section className="behind-the-scene-animal p-100">
      <Container>
        <Row className="mb-4 mb-md-5">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#202020" }}>
              <span style={{ color: "#00806F" }}>
                Behind the Scenes of Animal Debt Disaster
              </span>{" "}
              TekRevol’s Step-by-Step Development Process
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="">
            <div className="behind-main">
              <div className="behind-flex">
                <div className="behind-box left-box">
                  <h5>Discovery & Research</h5>
                  <p>
                    We conducted market analysis to identify gaps in the puzzle
                    genre and fully understood Gray’s vision for a humorous,
                    absurd game that challenges traditional puzzle mechanics.
                  </p>
                </div>
                <div
                  className="num left-padd"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  01
                </div>
              </div>
            </div>
            <div className="behind-main">
              <div className="behind-flex">
                <div className="behind-box left-box">
                  <h5>Technology & Feature Integration</h5>
                  <p>
                    Unity was used for immersive gameplay, PlayFab enabled
                    seamless multiplayer functionality, and Photoshop brought
                    quirky characters and environments to life, contributing to
                    the game’s unique aesthetic.
                  </p>
                </div>
                <div
                  className="num left-padd"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  03
                </div>
              </div>
            </div>

            <div className="behind-main">
              <div className="behind-flex">
                <div className="behind-box left-box">
                  <h5>Post-Deployment Support</h5>
                  <p>
                    We regularly updated the game with new puzzles and hilarious
                    features, maintaining player engagement and ensuring it
                    remained a hit among users and content creators alike.
                  </p>
                </div>
                <div
                  className="num left-padd"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  05
                </div>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={2}
            lg={2}
            xl={2}
            xxl={2}
            className="text-center column-none"
          >
            <StaticImage
              src="../../../images/case-studies/animal-debt/behind-case.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={16}
              height={1435}
            />
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="">
            <div className="behind-main">
              <div className="behind-flex">
                <div
                  className="num right-padd"
                  style={{
                    backgroundImage: `url(${BgImg1})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  02
                </div>
                <div className="behind-box right-box">
                  <h5>Design & Development</h5>
                  <p>
                    The game’s playful UI/UX, designed with vibrant colors and
                    quirky animations, was balanced with a robust backend built
                    to handle large user volumes, ensuring a seamless and fun
                    experience.
                  </p>
                </div>
              </div>
            </div>

            <div className="behind-main">
              <div className="behind-flex">
                <div
                  className="num right-padd"
                  style={{
                    backgroundImage: `url(${BgImg1})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  04
                </div>
                <div className="behind-box right-box">
                  <h5>Deployment & Testing</h5>
                  <p>
                    After launching on Android, we ensured bug-free gameplay
                    through multiple quality assurance rounds, ensuring the
                    game’s ridiculous elements worked as intended.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Behindthesceneanimal;
